import script from "./Test.vue?vue&type=script&setup=true&lang=js"
export * from "./Test.vue?vue&type=script&setup=true&lang=js"

import "./Test.vue?vue&type=style&index=0&id=0538db87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0538db87"]])

export default __exports__